import './App.css';
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './LoginPage';
import Navigation from './Navigation';
import HomeComponent from './HomeComponent';
import SignalComponent from './SignalComponent';
import PositionComponent from './PositionComponent';
import HistoryComponent from './HistoryComponent';
import NewsComponent from './NewsComponent';
import AIInsightComponent from './AIInsightComponent';
import AIRecommendationComponent from './AIRecommendationComponent';
import GrowthComponent from './GrowthComponent';

function App() {

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleLogin = () => {
    setIsLoggedIn(true);
  };


  return (
    <div className="App">
      <Router>
        {isLoggedIn ? (
          <>
            <Navigation />
            <Routes>
              <Route path="/" exact element={<HomeComponent />} />
              <Route path="/signals" element={<SignalComponent />} />
              <Route path="/positions" element={<PositionComponent />} />
              <Route path="/history" element={<HistoryComponent />} />
              <Route path="/news" element={<NewsComponent />} />
              <Route path="/aiinsights" element={<AIInsightComponent />} />
              <Route path="/airecommendations" element={<AIRecommendationComponent />} />
              <Route path="/growth" element={<GrowthComponent />} />
            </Routes>
          </>
        ) : (
          <LoginPage onLogin={handleLogin} />
        )}
      </Router>
    </div>
  );
}

export default App;
